import { render, staticRenderFns } from "./ProductModifyItemListTable.vue?vue&type=template&id=b41d2c6a&scoped=true&"
import script from "./ProductModifyItemListTable.vue?vue&type=script&lang=js&"
export * from "./ProductModifyItemListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductModifyItemListTable.vue?vue&type=style&index=0&id=b41d2c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41d2c6a",
  null
  
)

export default component.exports